import { createContext, useState } from "react";
export const languagecontext = createContext();
export default function LanguageContext({ children }) {
	const [isRTL, setRTL] = useState(false);
	const [lang, setLang] = useState("en");
	const [reRender, setReRender] = useState(false);
	return (
		<>
			<languagecontext.Provider
				value={{ isRTL, setRTL, lang, setLang, reRender, setReRender }}
			>
				{children}
			</languagecontext.Provider>
		</>
	);
}
